import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "src/components/pages/landing/landingPage";
import TemplatesPage from "src/components/pages/templates/templatesPage";
import { useAppDispatch } from "src/store/store";
import {
  getAllInspectionTemplates,
  getInspectionsByUser,
} from "src/store/dataSlice";
import QuestionsPage from "./pages/questions/questionsPage";
import InspectionPage from "./pages/inspection/inspectionPage";
import AdminLayout from "./pages/admin/adminLayout";
import RequireAdmin from "./pages/admin/requireAdmin";
import CompletedInspections from "./pages/inspection/completedInspections";
import CompletedInspectionDetails from "./pages/inspection/completedInspectionDetails";
const AuthorizedContent = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAllInspectionTemplates());
    dispatch(getInspectionsByUser());
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<LandingPage />} />
      <Route
        path="/admin/*"
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/templates/:templateId" element={<QuestionsPage />} />
      <Route
        path="/templates/:templateId/inspection"
        element={<InspectionPage />}
      />
      <Route path="/completedInspections" element={<CompletedInspections />} />
      <Route
        path="/completedInspections/:inspectionId"
        element={<CompletedInspectionDetails />}
      />
    </Routes>
  );
};

export default AuthorizedContent;
